import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "instructions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_warning_note = _resolveComponent("app-warning-note")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_warning_note),
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("instructions.title")), 1),
      _createElementVNode("ol", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.getLocaleMessage(_ctx.$i18n.locale).instructions
          .paragraphs, (point, idx) => {
          return (_openBlock(), _createElementBlock("li", { key: idx }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(point, (p, pIdx) => {
              return (_openBlock(), _createElementBlock("p", { key: pIdx }, _toDisplayString(p), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 64))
}